export default __webpack_public_path__ + "c12c34cb56baa34570df161debefa82c.jpg";